import api from './api';

export const updateWorkspace = async (workspace, agencyId) => {
  try {
    const contentTags = workspace.contentTags;

    const request = {};
    request.customer = workspace;
    request.customer.contentTags = {};

    const customerAndContentTags = {
      customer: workspace,
      contentTags: contentTags,
    };

    return await api.post(
      '/rest/dashboard/customer/update',
      customerAndContentTags,
      {
        headers: { 'x-agency-id': agencyId },
      },
    );
  } catch (error) {
    console.error('Error updating workspace:', error);
    throw error;
  }
};

export const getWorkspaces = async ({
  page,
  pageSize,
  agencyId,
  includeWorkspaceTags = false,
}) => {
  try {
    const requestUrl = `/rest/agency?page=${page}&pageSize=${pageSize}&includeWorkspaceTags=${includeWorkspaceTags}`;
    return await api.get(requestUrl, { headers: { 'x-agency-id': agencyId } });
  } catch (error) {
    console.error('Error fetching workspaces:', error);
    throw error;
  }
};

export const createWorkspace = async ({ workspace }) => {
  try {
    const workspaceData = {
      companyName: workspace.workspaceName,
      timezone: workspace.timezone,
    };
    return await api.post('/rest/dashboard/addBrand', workspaceData);
  } catch (error) {
    console.error('Error adding workspace:', error);
    throw error;
  }
};

export const deleteWorkspace = async ({ workspaceId }) => {
  try {
    return await api.delete(`/rest/dashboard/brand?id=${workspaceId}`);
  } catch (error) {
    console.error('Error deleting workspace:', error);
    throw error;
  }
};

export const activateWorkspace = async (agencyId, workspaceId) => {
  try {
    return await api.put(
      `/api/v1/workspace/${workspaceId}/convert`,
      undefined,
      {
        headers: { 'x-agency-id': agencyId },
      },
    );
  } catch (error) {
    console.error('Error converting workspace trial:', error);
    throw error;
  }
};
